module.exports = __webpack_public_path__ + "static/img/2.3c39f86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/kmR410A/2.jpg
// module id = s3jd
// module chunks = 1